export class StringUtilities {

  /**
   * 
   * Usage: FormatString("{0} is {1} {2}", "This", "formatting", "hack");
   * 
   * @param str      
   * @param val 
   */
  public static formatString(str: string, ...val: string[]): string {
    for (let index = 0; index < val.length; index++) {
      str = str.replace(`{${index}}`, val[index]);
    }
    return str;
  }

  public static uppercaseFirstLetter(sentence: string): string {       
      return sentence.toLowerCase()
      .split(' ')
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');    
  }
}
